import React from "react";
import tw from "tailwind-styled-components";
import { Formik, Form, Field } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import { toast } from "react-toastify";
import * as Yup from "yup";
import DropzoneImageUpload from "./DropZone";

const AddStamp = ({
  AddStampPaperMutate,
  AddStampPaperLoading,
  setAddStampPaper,
  setSelectedData,
  selectedData,
}) => {
  const name = (name) => {
    if (!name) return "";
    const lowerCaseName = name.trim().toLowerCase();
    return lowerCaseName.length > 10
      ? `${lowerCaseName.slice(0, 10)}...`
      : lowerCaseName;
  };

  const InitialValues = {
    stampId: "",
    firstParty: "",
    stampImage: "",
  };

  const validationSchema = Yup.object({
    stampId: Yup.string().required("Please enter stamp id"),

    firstParty: Yup.string().required("Please enter first party name "),
  });
  const SubmitHandler = (values) => {
    if (!values.stampImage && !selectedData?.url) {
      toast.error("Please upload the stamp page.");
      return;
    }
    AddStampPaperMutate(values);
  };

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setAddStampPaper}>
      <Title>Upload Stamp</Title>

      {AddStampPaperLoading && <Loading />}

      {!AddStampPaperLoading && (
        <Formik
          initialValues={InitialValues}
          validationSchema={validationSchema}
          onSubmit={SubmitHandler}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              <Wrapper>
                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="stampId">Stamp Id</Label>
                    <Field name="stampId">
                      {({ field, meta }) => (
                        <>
                          <Input
                            {...field}
                            type="text"
                            placeholder="Enter Stamp Id"
                            autoComplete="off"
                          />

                          {meta.touched && meta.error && (
                            <ErrorText>{meta.error}</ErrorText>
                          )}
                        </>
                      )}
                    </Field>
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="firstParty">First Party</Label>
                    <Field name="firstParty">
                      {({ field, form, meta }) => (
                        <>
                          <Input
                            {...field}
                            type="text"
                            placeholder="Enter First Party"
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[0-9]/g,
                                "",
                              );

                              form.setFieldValue("firstParty", value);
                            }}
                            autoComplete="off"
                          />

                          {meta.touched && meta.error && (
                            <ErrorText>{meta.error}</ErrorText>
                          )}
                        </>
                      )}
                    </Field>
                  </InputGroup>
                </CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="stampImage">Upload Stamp Image</Label>
                  <div>
                    <DropzoneImageUpload
                      setUploadFile={(file) => (values.stampImage = file)}
                      componentFor="stampImage"
                    />
                  </div>
                </InputGroup>

                {selectedData?.url && (
                  <InputGroup>
                    <div className="flex items-center mt-[-15px]">
                      <svg
                        className="h-4 w-4 text-primary-color"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      <a
                        href={selectedData.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-primary-color ml-1 text-sm"
                      >
                        {name(selectedData?.firstPartyName)}/stamp.png
                      </a>
                    </div>
                  </InputGroup>
                )}
              </Wrapper>
              <BtnWrapper>
                <SubmitBtn type="submit">Upload</SubmitBtn>
              </BtnWrapper>
            </Form>
          )}
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`grid gap-6 my-6 px-1 `;
const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div` w-full flex items-center justify-center space-x-10 mt-8`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 h-10`;
const ErrorText = tw.div`text-red-500 text-sm`;

export default AddStamp;